import { PageExperience } from "./components/PageExperience";
import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
const AppShell = lazy(() =>
  import("./layouts/AppShell").then((module) => ({ default: module.AppShell })),
);
import { AuthPage } from "./pages/AuthPage";
const AccountPage = lazy(() =>
  import("./pages/AccountPage").then((module) => ({
    default: module.AccountPage,
  })),
);
import { RequireAuth } from "./components/RequireAuth";
import { WorkspacePermission } from "./components/WorkspacePermission";
const BillingPage = lazy(() =>
  import("./pages/BillingPage").then((module) => ({
    default: module.BillingPage,
  })),
);
const ConversationsPage = lazy(() =>
  import("./pages/ConversationsPage").then((module) => ({
    default: module.ConversationsPage,
  })),
);
import { HelpPage } from "./pages/HelpPage";
const InsightsPage = lazy(() =>
  import("./pages/InsightsPage").then((module) => ({
    default: module.InsightsPage,
  })),
);
import { LandingPage } from "./pages/LandingPage";
import { LegalPage } from "./pages/LegalPage";
const MembersPage = lazy(() =>
  import("./pages/MembersPage").then((module) => ({
    default: module.MembersPage,
  })),
);
const NewProjectPage = lazy(() =>
  import("./pages/NewProjectPage").then((module) => ({
    default: module.NewProjectPage,
  })),
);
import { NotFoundPage } from "./pages/NotFoundPage";
const ProjectPage = lazy(() =>
  import("./pages/ProjectPage").then((module) => ({
    default: module.ProjectPage,
  })),
);
const ProjectsPage = lazy(() =>
  import("./pages/ProjectsPage").then((module) => ({
    default: module.ProjectsPage,
  })),
);

const DashboardPage = lazy(() =>
  import("./pages/DashboardPage").then((module) => ({
    default: module.DashboardPage,
  })),
);

function RouteFallback() {
  return (
    <div className="route-fallback" role="status">
      <span />
      Carregando painel…
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <PageExperience />
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/privacy" element={<LegalPage />} />
          <Route path="/terms" element={<LegalPage />} />
          <Route path="/security" element={<LegalPage />} />
          <Route
            path="/app"
            element={
              <RequireAuth>
                <AppProvider>
                  <AppShell />
                </AppProvider>
              </RequireAuth>
            }
          >
            <Route
              index
              element={
                <Suspense fallback={<RouteFallback />}>
                  <DashboardPage />
                </Suspense>
              }
            />
            <Route path="projects" element={<ProjectsPage />} />
            <Route
              path="projects/new"
              element={
                <WorkspacePermission capability="createProject">
                  <NewProjectPage />
                </WorkspacePermission>
              }
            />
            <Route path="projects/:projectId" element={<ProjectPage />} />
            <Route
              path="conversations"
              element={
                <WorkspacePermission capability="viewConversations">
                  <ConversationsPage />
                </WorkspacePermission>
              }
            />
            <Route
              path="insights"
              element={
                <WorkspacePermission capability="viewInsights">
                  <InsightsPage />
                </WorkspacePermission>
              }
            />
            <Route
              path="members"
              element={
                <WorkspacePermission capability="manageMembers">
                  <MembersPage />
                </WorkspacePermission>
              }
            />
            <Route
              path="billing"
              element={
                <WorkspacePermission capability="viewBilling">
                  <BillingPage />
                </WorkspacePermission>
              }
            />
            <Route path="help" element={<HelpPage />} />
            <Route path="account" element={<AccountPage />} />
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
